import { useDialogStore } from '@/store';

export function useResponse() {
	const setDialog = useDialogStore((s) => s.setStore);
	const setAction = useDialogStore((s) => s.setAction);
	const onOpen = useDialogStore((s) => s.onOpenChange);

	function onSuccess({
		message,
		onConfirm
	}: {
		message: string | React.ReactNode,
		onConfirm?: () => void
	}) {
		setDialog('variant', 'success');
		setDialog('title', 'Berhasil');
		setDialog('description', message);
		setDialog('confirmText', 'OK');
		setDialog('cancelText', null);
		setAction('onConfirm', () => {
			onConfirm?.();
			onOpen(false);
		});
		setDialog('open', true);
	}
	function onError({
		message,
		confirmText = 'OK',
		cancelText = null
	}: {
		message: string,
		confirmText?: string,
		cancelText?: string | null
	}) {
		setDialog('variant', 'error');
		setDialog('title', 'Gagal');
		setDialog('description', message);
		setDialog('confirmText', confirmText);
		setDialog('cancelText', cancelText);
		setAction('onConfirm', () => onOpen(false));
		setDialog('open', true);
	}

	return { onSuccess, onError };
}
